import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  Label,
  Row,
  Col,
  Button,
} from 'reactstrap'
import moment from '../../../lib/moment.js'
import styled from 'styled-components'
import { selectColor } from '../../../function'
import { FONTS } from '../../../constants/index.js'

class LeaveHistoryDetail extends React.Component {
  isEmpty = (text) => {
    return text && text !== '' ? text : '-'
  }

  render() {
    const { open, toggle, history } = this.props

    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ open }
        toggle={ () => toggle() }
      >
        <HeaderForm toggle={ () => toggle() }>
          <HeadLabel>Leave History Detail</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <Container>
            <LabelTextInfo>Employee Name</LabelTextInfo>
            <Row >
              <ColDataInfo>
                { this.isEmpty(history.emp_name) }
              </ColDataInfo>
            </Row>
            <LabelTextInfo>Leave Type</LabelTextInfo>
            <Row >
              <ColDataInfo>
                { this.isEmpty(history.leave_type_name) }
              </ColDataInfo>
            </Row>
            <LabelTextInfo>Leave Date</LabelTextInfo>
            <Row >
              <ColDataInfo>
                { this.isEmpty(moment(history.start_date).format('DD/MM/YYYY')) } - { this.isEmpty(moment(history.end_date).format('DD/MM/YYYY')) }
              </ColDataInfo>
            </Row>
            <LabelTextInfo>Total Leave Day</LabelTextInfo>
            <Row >
              <ColDataInfo>
                { this.isEmpty(history.days) } days
              </ColDataInfo>
            </Row >
            <React.Fragment>
              <LabelTextInfo>Attachments</LabelTextInfo>
              <ColButton>
                { history.attachment_url && history.attachment_url !== '' ?
                  <CustomButton
                    color="info"
                    onClick={ () => window.open(history.attachment_url, 'blank') }
                  >
                  Download
                  </CustomButton>
                  :
                  <p>-</p>
                }
              </ColButton>
            </React.Fragment>
            <LabelTextInfo>Status</LabelTextInfo>
            <Row>
              <ColDataInfo>
                <p style={ { color: selectColor(this.isEmpty(history.status)) } }>
                  { this.isEmpty(history.status) }
                </p>
              </ColDataInfo>
            </Row>
            <LabelTextInfo>Remarks</LabelTextInfo>
            <Row>
              <ColDataInfo>
                { this.isEmpty(history.remark_request_user) }
              </ColDataInfo>
            </Row>
            <LabelTextInfo>Approver Remarks</LabelTextInfo>
            <Row>
              <ColDataInfo>
                { this.isEmpty(history.remark_approver) }
              </ColDataInfo>
            </Row>
            <LabelTextInfo>HR Remarks</LabelTextInfo>
            <Row>
              <ColDataInfo>
                { this.isEmpty(history.remark_hr) }
              </ColDataInfo>
            </Row>
            <LabelTextInfo>Cancel Remarks</LabelTextInfo>
            <Row>
              <ColDataInfo>
                { this.isEmpty(history.remark_cancel) }
              </ColDataInfo>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    )
  }
}

LeaveHistoryDetail.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func,
  history: PropTypes.object,
}
LeaveHistoryDetail.defaultProps = {
  open: false,
  toggle: () => {},
  history: {},
}

export default LeaveHistoryDetail

const HeaderForm = styled(ModalHeader)`
    font-family: 'Gotham-Bold' !important;
    font-size: 12px ;
`
const HeadLabel = styled(Label)`
    font-family: 'Gotham-Bold' !important;
    font-size: 16px ;
    color: #AD2624;
    margin-left: 5px;
`
const LabelTextInfo = styled(Label)`
    font-family: 'Gotham-Bold' !important;
    font-size: 14px ;
    margin-bottom: 1%;
`
const ColDataInfo = styled(Col)`
    font-family: 'Gotham' !important;
    font-size: 14px ;
`

const ColButton = styled(Col)`
  padding: 0;
`

const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`



// WEBPACK FOOTER //
// ./src/components/report/modal/leave-history-detail.js